import { instance2 } from '@/controller/base';
import { AUTH_KEYS, getAuthToken } from '@/shared/utils/authStorage';

const apiMiddleware = () => {
    return (storeAPI) => {
        return (next) => async (action) => {
            if (action.type === 'CALL_API') {
                let method = action.method;
                let res = {};
                // let url = apiRoute[action.url] === undefined ? '_invalid_url_' : apiRoute[action.url];
                // console.log(url);
                switch (method.toLowerCase()) {
                    case 'get':
                        try {
                            await instance2
                                .get(action.url, {
                                    params: action.data,
                                    headers: {
                                        Authorization: action.auth
                                            ? `Bearer ${getAuthToken(AUTH_KEYS.ACCESS_TOKEN)}`
                                            : '',
                                    },
                                })
                                .then((response) => {
                                    res = {
                                        status: response.status,
                                        msg: response.data.msg,
                                        data: response.data.data === undefined ? {} : response.data.data,
                                    };
                                })
                                .catch((error) => {
                                    res = {
                                        status: error.response ? error.response.status : 500,
                                        msg: error.message,
                                        data: '',
                                    };
                                });
                        } catch (e) {
                            res = {
                                status: 10001,
                                msg: e.message,
                                data: '',
                            };
                        }
                        res.type = 'CALL_API';
                        return next(res);
                    case 'post':
                        try {
                            await instance2
                                .post(action.url, action.data, {
                                    headers: {
                                        Authorization: action.auth
                                            ? `Bearer ${getAuthToken(AUTH_KEYS.ACCESS_TOKEN)}`
                                            : '',
                                        'Accept-Language':
                                            localStorage.getItem('lang') === null ? 'en' : localStorage.getItem('lang'),
                                    },
                                })
                                .then((response) => {
                                    //success
                                    res = {
                                        status: response.status,
                                        msg: convertMsg(response.data),
                                        data: response.data.results === undefined ? {} : response.data.results,
                                    };
                                })
                                .catch((error) => {
                                    //sini ada error
                                    res = {
                                        status: error.response ? error.response.status : 500,
                                        msg: error.message,
                                        data: '',
                                    };
                                });
                        } catch (e) {
                            res = {
                                status: 10001,
                                msg: e.message,
                                data: '',
                            };
                        }
                        res.type = 'CALL_API';
                        return next(res);
                    case 'put':
                        try {
                            await instance2
                                .put(action.url, action.data, {
                                    headers: {
                                        Authorization: action.auth
                                            ? `Bearer ${getAuthToken(AUTH_KEYS.ACCESS_TOKEN)}`
                                            : '',
                                        'Accept-Language':
                                            localStorage.getItem('lang') === null ? 'en' : localStorage.getItem('lang'),
                                    },
                                })
                                .then((response) => {
                                    //success
                                    res = {
                                        status: response.status,
                                        msg: convertMsg(response.data),
                                        data: response.data.results === undefined ? {} : response.data.results,
                                    };
                                })
                                .catch((error) => {
                                    //sini ada error
                                    res = {
                                        status: error.response ? error.response.status : 500,
                                        msg: error.message,
                                        data: '',
                                    };
                                });
                        } catch (e) {
                            res = {
                                status: 10001,
                                msg: e.message,
                                data: '',
                            };
                        }
                        res.type = 'CALL_API';
                        return next(res);
                    case 'delete':
                        try {
                            await instance2
                                .delete(action.url, {
                                    headers: {
                                        Authorization: action.auth
                                            ? `Bearer ${getAuthToken(AUTH_KEYS.ACCESS_TOKEN)}`
                                            : '',
                                        'Accept-Language':
                                            localStorage.getItem('lang') === null ? 'en' : localStorage.getItem('lang'),
                                    },
                                })
                                .then((response) => {
                                    //success
                                    res = {
                                        status: response.status,
                                        msg: convertMsg(response.data),
                                        data: response.data.results === undefined ? {} : response.data.results,
                                    };
                                })
                                .catch((error) => {
                                    //sini ada error
                                    res = {
                                        status: error.response ? error.response.status : 500,
                                        msg: error.message,
                                        data: '',
                                    };
                                });
                        } catch (e) {
                            res = {
                                status: 10001,
                                msg: e.message,
                                data: '',
                            };
                        }
                        res.type = 'CALL_API';
                        return next(res);
                    default:
                        res = {
                            status: 10001,
                            msg: 'Invalid method',
                            data: '',
                        };
                        res.type = 'CALL_API';
                        return next(res);
                }
            }
            return next(action);
        };
    };
};

const convertMsg = (data) => {
    if (data.msg) {
        return data.msg;
    } else if (data.message) {
        return data.message;
    } else if (data.error) {
        return data.error;
    } else {
        return 'Success';
    }
};

export default apiMiddleware;
